export default __webpack_public_path__ + "static/media/heart_filled.a57bc777.svg";